import React from 'react'
import './styles.scss'
const meta = require('../../../.taStandalonerc.yml')
import { MetaInfos } from 'components/MetaInfos'

interface Props {
  updated?: string|JSX.Element
}

export const HeaderStandaloneRC = ({ updated }: Props) => (
  <div className='HeaderStandaloneRC'>
    <header className='ui vertical  very fitted  segment'>
      <div className='ui container'>
        <div className='ui header'>
          <h1>{meta.pageTitle}</h1>
          <h2>{meta.description}</h2>
        </div>
      </div>
    </header>
    <div className='ui vertical  very fitted  segment'>
      <div className='ui text container'>
        <MetaInfos
          authors={meta.author.split(', ')}
          updated={updated ? updated : undefined}
        />
      </div>
    </div>
  </div>
)
